module.exports = __webpack_public_path__ + "static/media/github2.148afbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/images/github2.png
// module id = 131
// module chunks = 0